import styled from "@emotion/styled";


export const FlexCenter = styled("div")(({ theme }) => ({
    display: "flex" ,
    justifyContent : "center" , 
    alignItems : "center" , 
}));